// snippetAliasStop — a Monaco snippet body for SQL whose new relation's alias
// is the `${1}` tab stop (the join snippets' `${1:alias}` mirrors). The SQL is
// rendered with the real alias, then once more with a stand-in character that
// occurs nowhere in that rendering: only the places the builder wrote the
// alias can hold it, so no user text — a filter literal that reads like a
// placeholder or a marker — is ever taken for the alias.

/** Escape literal text for a Monaco snippet body (`$`, `}` and `\` are syntax there). */
export function escapeSnippetText(text: string): string {
  return text.replace(/[\\$}]/g, (c) => `\\${c}`);
}

/**
 * `render(alias)` as an escaped snippet body with every place `render` wrote
 * the alias turned into the `${1}` tab stop. `render` must write its argument
 * verbatim and not otherwise depend on it; null when the two renderings
 * disagree (the caller keeps the literal alias).
 */
export function snippetWithAliasStop(render: (alias: string) => string, alias: string): string | null {
  const plain = render(alias);
  const standIn = unusedCharacter(plain);
  const parts = render(standIn).split(standIn);
  return parts.join(alias) === plain ? parts.map(escapeSnippetText).join('${1}') : null;
}

/** A private-use character absent from `text` (a text holds far fewer distinct characters than the range). */
function unusedCharacter(text: string): string {
  let code = 0xe000;
  while (code < 0xf8ff && text.includes(String.fromCharCode(code))) code++;
  return String.fromCharCode(code);
}
